<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <ClientNav/>
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form"
              lazy-validation>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-select
                      v-model="newTask"
                      label="Select Event"
                      :items="taskList"
                      @change="visit()"
                      :rules="requiredField"
                    ></v-select>
                  </v-col>
                  <template v-if="drsVisit">
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="newProviderType"
                        label="Providers"
                        :items="providers"
                        item-text="Provider.Name"
                        item-value="Provider._id"
                        :rules='requiredField'
                      >
                        <template v-slot:prepend-item>
                          <v-list-item>
                            <v-list-item-content>
                              <v-text-field
                                v-model="search"
                                placeholder="Search"
                                @input="searchProvider"
                              />
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="newVisitType"
                        label="Visit Type"
                        :items="sortedVisitType"
                        item-value="Name"
                        item-text="Name"
                        :rules='requiredField'
                      ></v-select>
                    </v-col>
                  </template>
                  <v-col cols="12" sm="12" md="4">
                    <v-autocomplete
                      v-model="newStaffAssigned"
                      :items="users"
                      item-text="Name"
                      item-value="_id"
                      label="Staff Assigned"
                      clearable
                      :rules="requiredField"
                      return-object
                      :filter="customFilter"
                    >
                      <template #selection="{ item }">
                        <v-chip :key="item._id" v-if="item">{{ item.Name }}</v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-select
                      v-model="newProgram"
                      :items="selectedClientPrograms"
                      label="Program"
                      :rules="requiredField"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Notes"
                      v-model="newNotes"
                      outlined
                    ></v-textarea>
                  </v-col>
                  <v-row>
                    <template>
                      <v-col cols="12" sm="12" md="6">
                        <v-datetime-picker
                          :label="`${newTask} Start Date and Time`"
                          v-model="newDueStartTime"
                          prepend-icon="mdi-calendar"
                        ></v-datetime-picker>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-datetime-picker
                          :label="`${newTask} End Date and Time`"
                          v-model="newDueEndTime"
                          prepend-icon="mdi-calendar"
                        ></v-datetime-picker>
                      </v-col>
                    </template>
                  
                  </v-row>


                  <v-col cols="12" sm="12" md="12">
                    <span>Is Transportation Required?</span>
                    <v-switch label="Yes" value="Yes" v-model="newTransportation"></v-switch>
                    <v-switch label="No" value="No" v-model="newTransportation"></v-switch>
                  </v-col>
                  <v-col v-if="newTransportation === 'Yes'" cols="12" sm="12" md="4">
                    <v-text-field
                      label="Transportation From"
                      v-model="newFrom"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="newTransportation === 'Yes'" cols="12" sm="12" md="4">
                    <v-text-field
                      label="Transportation To"
                      v-model="newTo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      readonly
                      v-model="newDateCreated"
                      label="Date Created"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Created By"
                      v-model="newCreatedBy"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="12" md="2">
                      <v-checkbox
                          v-model="signed"
                          label="Completed By"
                          hint="Sign only after the appointment has been attended and completed"
                          @click="addSignature()"
                      ></v-checkbox>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field v-model="newCompletedBy" readonly v-if="signed === true"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              fab
              small
              @click="showPrintModal()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="!newEvent"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn class="white--text" color="#259647" @click="addEvent()" v-if="newEvent && !isAuditorRole">Save
            </v-btn>
            <v-btn color="blue darken-1" text @click="updateEvent()" v-if="!newEvent && !isAuditorRole">Update
            </v-btn
            >
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import {mapActions} from "vuex";

const ClientService = require('../../service/client.service');
import ClientNav from "@/components/ClientNav.vue";

const UnitService = require('../../service/unit.service');
const url = require("../../client_config/config").url;
import Swal from 'sweetalert2';

export default {
  components: {
    ClientNav,
  },
  data() {
    return {
      clientID: this.$route.params.clientID,
      id: this.$route.params.id,
      search: "",
      titleForm: "New Event",
      newTask: "",
      newStaffAssigned: "",
      newNotes: "",
      newTransportation: "",
      newFrom: "",
      newTo: "",
      newDueDate: null,
      newTime: "",
      newDateCreated: new Date(),
      newCreatedBy: localStorage.getItem('Name'),
      newCompletedBy: "",
      eventID: "",
      users: [],
      taskList: [
        "Activity",
        "Appointment",
        "Birthday",
        "Bus",
        "Dr. Visit",
        "Family Visit",
        "Meeting",
        "Menu",
        "Other",
        "Reminder",
        "Transportation",
        "Vocational Rehabilitation",
        "Maintenance",
        "Work"
      ],
      drsVisit: false,
      providers: [],
      signed: '',
      newProviderType: "",
      visitType: [
        "Admitting Physician",
        "Allergist",
        "Appointed Attorney",
        "Attending Physician",
        "Appointed Attorney",
        "Audiologist",
        "Behaviorist",
        "Cardiologist",
        "Care Worker Supervisor",
        "Case Worker",
        "Chiropractor",
        "Counselor/Therapist",
        "Dentist",
        "Dermatologist",
        "Ears, Nose and Throat (ENT)",
        "Emergency Room",
        "Employer",
        "Endocrinologist",
        "Gastroenterologist",
        "Gynecologist",
        "Hospital",
        "Lab",
        "Legal Guardian",
        "Nephrologist",
        "Neurologist",
        "Nurse",
        "Nurse Practitioner",
        "Nutritionist/Dietician",
        "Occupational Therapist",
        "Optometrist/Ophthalmologist",
        "Orthopedic",
        "Parent (Connect Access)",
        "Pharmacy",
        "Phlebotomist",
        "Physical Therapist",
        "Physician or Specialist",
        "Physician Assistant",
        "Podiatrist",
        "Primary Care MD",
        "Psychiatrist",
        "Public Guardian",
        "Radiologist",
        "Sleep Specialist",
        "Support Coordinator",
        "Surgeon",
        "Urologist",
        "Urgent Care",
        "Work Site",
        "Wound Care"
      ],
      newVisitType: "",
      newProgram: '',
      selectedClientPrograms: [],
      userState: localStorage.getItem('userState'),
      requiredField: [v => !!v || 'This is required'],
      clientProviders: [],
      medicalVisit: null,
      msg: false,
      text: "",
      newEvent: false,
      event: {},
      newDueStartTime: null,
      newDueEndTime: null,
    };
  },

  created() {
    this.newEvent = this.$route.query.newEvent === 'true';
  },

  computed: {
    sortedVisitType() {
      return this.visitType.slice().sort();
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  async mounted() {
    await this.getProviders();
    this.setProgram();
    this.getUsers();

    if (!this.newEvent) {
      this.getEvent();
    }
  },

  methods: {
    ...mapActions({
      getClientProviders: "clientProviders/getItem",
      addItem: "events/addItem",
    }),


    close() {
      this.clear();
      this.$router.go(-1);
    },

    validate() {
      return this.$refs.form.validate();
    },

    async getProviders() {
      const response = await this.getClientProviders(this.clientID);
      this.providers = response.data;
      console.log({providers: this.providers});
      this.clientProviders = this.providers;
    },


    getUsers() {
      const companyIds = localStorage.getItem('userCompanies');
      let params = {
        Company: JSON.parse(companyIds),
        page: 1,
        limit: 50
      };

      this.getPaginatedUsers(params);
    },

    getPaginatedUsers(params) {
      let endpoint = `${url}/users/state/${this.userState}`;

      axios.get(endpoint, {params}).then((res) => {
        if (res.data.users.length > 0) {
          this.users = this.users.concat(res.data.users);
        }

        if (res.data.totalUsers > this.users.length) {
          params.page++;
          this.getPaginatedUsers(params);
        }
      });
    },

    visit: function () {
      if (this.newTask === "Dr. Visit") {
        this.drsVisit = true;
      } else {
        this.drsVisit = false;
      }
    },

    async addEvent() {
      if (this.validate()) {
          if (!this.newDueStartTime || !this.newDueEndTime) {
            alert('Please fill up appointment start and end date/time');
            return;
          }
        
        const companyIds = localStorage.getItem('userCompanies')

        // Convert dates to ISO string
        const startDate = new Date(this.newDueStartTime).toISOString();
        const endDate = new Date(this.newDueEndTime).toISOString();
     
        let req_body = {
          Event: this.newTask,
          Client: this.clientID,
          Program: this.newProgram,
          Staff: this.newStaffAssigned,
          Notes: this.newNotes,
          Transportation: this.newTransportation,
          To: this.newTo,
          From: this.newFrom,
          StartDate: startDate,
          EndDate: endDate,
          CreatedDate: new Date(this.newDateCreated).toISOString(),
          CreatedBy: this.newCreatedBy,
          Signature: this.newCompletedBy,
          ReviewingProvider: this.newProviderType,
          VisitType: this.newVisitType,
          UpcomingEvent: true,
          UrlNotification: this.$router.history.current.path,
          Company: JSON.parse(companyIds)
        };

        try {
          this.showLoadingAddDialog();
          const response = await this.addItem(req_body);
          if (response.status === 500) {
            return this.showErrorAddDialog();
          }
          this.eventID = response._id;
          this.showSuccessAddDialog();
          this.close();
        } catch (error) {
          console.error('Error adding item:', error);
          this.showErrorAddDialog();
          this.close();
        }
      }

    },

    addSignature() {
      if (!this.signed) {
        return this.newCompletedBy = ''
      }
      this.newCompletedBy = this.newCreatedBy + " - " + new Date();
      this.signed = true;
    },

    async onViewItem(item) {
      console.log({item});

      if (item.Program) {
        UnitService.getById(item.Program).then(response => {
          const {unit} = response.data;
          this.newProgram = unit.Name;
        });
      }

      this.titleForm = "Viewing " + item.Event;
      this.newTask = this.taskList.includes(item.Event) ? item.Event : this.taskList.push(item.Event);
      this.newStaffAssigned = item.Staff;
      this.newNotes = item.MedicalVisit?.Notes || item.Notes;
      this.newTransportation = item.Transportation;
      this.newFrom = item.From;
      this.newTo = item.To;
      this.newDueStartTime = new Date(item.StartDate);
      this.newDueEndTime = new Date(item.EndDate);
      


      this.newDateCreated = new Date(item.CreatedDate);
      this.newCreatedBy = item.CreatedBy;
      this.newCompletedBy = item.Signature;
      this.eventID = item._id;

      if (item.Event === 'Dr. Visit') {
        this.drsVisit = true;
        if (item.MedicalVisit) {
          this.newVisitType = item.MedicalVisit.VisitType || '';
          this.medicalVisit = item.MedicalVisit
          const itemProvider = this.providers.find(provider => provider.Provider._id.toString() === item.MedicalVisit.ReviewingProvider._id.toString()) || '';
          this.newProviderType = itemProvider.Provider._id || '';
        }
      }

      if (item.Signature !== "" && item.Signature !== undefined) {
        this.signed = true;
      }
      this.newTask = item.Event;
    },

    getEvent() {
      axios.get(`${url}/calendar/${this.id}`).then(response => {
        this.event = response.data;
        console.log({event: this.event});
        this.getProviders();
        this.onViewItem(this.event);
      }).catch(error => {
        console.error('Error fetching calendar event:', error);
      });
    },

    updateEvent() {
      if (!this.validate()) {
        alert('Please fill up the required fields.');
        return;
      }

      if (!this.newDueStartTime || !this.newDueEndTime) {
        alert('Please fill up appointment start and end date/time');
        return;
      }
      

      // Convert dates to ISO string
      const startDate = new Date(this.newDueStartTime).toISOString();
      const endDate = new Date(this.newDueEndTime).toISOString();
      
      const req_body = {
        Event: this.newTask,
        Client: this.clientID,
        Program: this.newProgram,
        Staff: this.newStaffAssigned,
        Notes: this.newNotes,
        Transportation: this.newTransportation,
        To: this.newTo,
        From: this.newFrom,
        StartDate: startDate,
        EndDate: endDate,
        CreatedDate: new Date(this.newDateCreated).toISOString(),
        CreatedBy: this.newCreatedBy,
        Signature: this.newCompletedBy,
        UpcomingEvent: true,
        ReviewingProvider: this.newProviderType,
        VisitType: this.newVisitType,
        UrlNotification: this.$router.history.current.path,
      };

      if (this.newTask === 'Dr. Visit') {
        req_body.MedicalVisit = this.medicalVisit;
      }

      this.showLoadingUpdateDialog();

      axios.put(`${url}/calendar/${this.id}`, req_body)
        .then((response) => {
          console.log({response});
          this.showSuccessUpdateDialog();
          this.close();
        })
        .catch((error) => {
          console.error('Error updating calendar event:', error);
          this.showErrorUpdateDialog();
          this.close();
        });
    },

    setProgram() {
      ClientService.getById(this.clientID).then(response => {
        const client = response.data.client;

        if (client && client[0].Program && client[0].Program.length) {
          this.selectedClientPrograms = client[0].Program;
          this.newProgram = client[0].Program;
        }
      });
    },

    clear() {
      this.newTask = "";
      this.newStaffAssigned = "";
      this.newNotes = "";
      this.newTransportation = "";
      this.newDueDate = moment().format('YYYY-MM-DD HH:mm');
      this.newDueStartTime = null;
      this.newDueEndTime = null;
      this.newFrom = "";
      this.newTo = "";
      this.newTime = "";
      this.newCompletedBy = this.newCreatedBy + " - " + new Date();
      this.newProviderType = "";
      this.newVisitType = "";
      this.newProgram = "";
      this.newDateCreated = moment().toLocaleString();
      this.newCreatedBy = localStorage.getItem('Name');
    },

    customFilter(item, queryText) {
      const searchText = queryText.toLowerCase();
      const itemName = item.Name.toLowerCase();
      return itemName.indexOf(searchText) > -1;
    },

    showPrintModal() {

      let id = this.eventID;
      let downloadUrl = `${url}/calendar/download?id=${id}`;

      // Show the "Print in progress" modal
      Swal.fire({
        title: 'Print in Progress',
        text: 'Please wait while the PDF is being generated and processed...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Make a request to the backend API to generate the PDF
      fetch(downloadUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const printWindow = window.open(blobUrl);

          printWindow.onload = function () {
            // Close the modal when the printing process is complete
            Swal.close();

            printWindow.print();

            URL.revokeObjectURL(blobUrl);
          };
        })
        .catch((error) => {
          console.error('Error generating or printing the PDF:', error);
          Swal.fire('Error', 'Failed to generate or print the PDF', 'error');
        });
    },

    searchProvider() {
      if (!this.search) {
        this.providers = this.clientProviders
      }

      this.providers = this.clientProviders.filter((item) => {
        return item.Provider.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    },

    showLoadingAddDialog() {
      Swal.fire({
        title: 'Creating Upcoming Event',
        html: 'Please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    },

    showLoadingUpdateDialog() {
      Swal.fire({
        title: 'Updating Upcoming Event',
        html: 'Please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    },

    showSuccessAddDialog() {
      Swal.fire({
        icon: 'success',
        text: 'A new upcoming event has been added successfully.',
        showConfirmButton: false,
        timer: 3000
      });
    },

    showSuccessUpdateDialog() {
      Swal.fire({
        icon: 'success',
        text: 'An upcoming event has been updated successfully.',
        showConfirmButton: false,
        timer: 3000
      });
    },

    showErrorAddDialog() {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while creating the event.',
        showConfirmButton: true,
        confirmButtonText: 'OK'
      });
    },

    showErrorUpdateDialog() {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while updating the event.',
        showConfirmButton: true,
        confirmButtonText: 'OK'
      });
    }
  },
};
</script>
